import React from 'react';
import Login from '../components/login';

export default function LoginPage() {
  return (
    <div>
      <Login />
    </div>
  );
}
